import { fetchDatalakeFile } from '@/services/http/datalake';

export const downloadJsonFileFromDatalake = async (
  fileName: string,
  groupName: string
): Promise<unknown> => {
  return fetchDatalakeFile({ fileName, groupName });
};
